import type { MouseEvent, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import LoopingEllipsis from '@/components/LoopingEllipsis';
import type { ButtonVariant } from './types';
import { classes, styles } from './utils';

export interface ButtonProps extends PropsWithChildren {
  busy?: boolean;
  disabled?: boolean;
  className?: string;
  busyLabel?: string;
  form?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariant;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

export default function Button({
  busy = false,
  disabled = false,
  className,
  busyLabel,
  form,
  type = 'button',
  variant = 'primary',
  onClick,
  children,
}: ButtonProps) {
  const showDisabled = disabled && !busy;
  return (
    <button
      type={type}
      form={form}
      disabled={disabled || busy}
      onClick={onClick}
      className={twMerge(
        classes.base,
        classes[variant],
        busy && classes.busy,
        showDisabled && classes.disabled,
        className
      )}>
      {busy && <span style={styles.spinner} className={classes.spinner} />}
      {busy && busyLabel ? (
        <>
          {busyLabel}
          <LoopingEllipsis />
        </>
      ) : (
        children
      )}
    </button>
  );
}
